import React from 'react';
import FontsMapper from "../services/FontsMapper";
import {
    calculateGridLines,
    convertCmToPx,
    convertMMtoPx,
    calculateActualSize,
    convertPxToCm,
    pickMeasurementChar
} from "../services/helpers";
const fontsMapper = new FontsMapper();
const PdfForStonemasons = ({
                               pdfItemsToRender,
                               data,
                               margin,
                               scale,
                               letterSpacing,
                               workingSize,
                               showGrid,
}) => {
    // Calculate grid lines for PDF (accounting for 0.75 scaling factor)
    const gridLines = workingSize?.widthCm && workingSize?.heightCm && data.gridSpacingCm
        ? calculateGridLines(workingSize.widthCm, workingSize.heightCm, data.gridSpacingCm)
        : { verticalLines: [], horizontalLines: [] };
    const sizeConf = data.selectedFontObject?.fonts_conf?.find(
        (f) => f.font_size?.slug === data.selectedFontSizeObject?.slug
    );
    const measurementChar = pickMeasurementChar({
        allowedBigLetters: sizeConf?.allowed_big_letters,
        allowedSmallLetters: sizeConf?.allowed_small_letters,
        allowedNumbers: sizeConf?.allowed_numbers,
        allowedSpecial: sizeConf?.allowed_special,
    });
    const actualFontSize = (section , fontsMapper , scaling = 0.75 ) => {
        return calculateActualSize(
            section.fontSizeValuePx,
            scaling,
            fontsMapper.fonts[data.selectedFontObject.woocommerce_product_id].clr[data.selectedFontSizeObject.slug].name,
            measurementChar
        )
    }
    const prepareHtml = (section , index) => {
        const html = `<style>
               #section-${index} p,
               #section-${index} span {
                    font-size: ${actualFontSize(section, fontsMapper).actualSize}px;
                    margin-top: ${actualFontSize(section, fontsMapper , 0.5).descent}px;
                    text-align: ${section.textAlign};
                    font-family: ${fontsMapper.fonts[data.selectedFontObject.woocommerce_product_id].clr[data.selectedFontSizeObject.slug].name};
                    letter-spacing: ${letterSpacing - convertPxToCm(16)}cm;
                    line-height: 1;
                    padding: 0!important;
                }

            </style>
            ${section.value}
            `
        return html;
    }
    return (
    <html lang="pl-PL">
    <body style={{
        padding: 0,
        margin: 0,
        position: 'relative',
        width: '100%',
        height: '100%',
    }}>
    {/* Grid overlay */}
    {showGrid && (
        <>
            {/* Vertical grid lines */}
            {gridLines.verticalLines.map((position, index) => (
                <div
                    key={`v-${index}`}
                    style={{
                        position: 'absolute',
                        left: `${(position * 0.75 )}px`,
                        top: 0,
                        display : 'block',
                        width: '1px',
                        height: convertCmToPx(workingSize.heightCm) * 0.75,
                        backgroundColor: 'rgba(204, 204, 204, 0.5)',
                        zIndex: 0,
                    }}
                />
            ))}
             {/*Horizontal grid lines*/}
            {gridLines.horizontalLines.map((position, index) => (
                <div
                    key={`h-${index}`}
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: `${(position * 0.75 )}px`,
                        width: convertCmToPx(workingSize.widthCm) * 0.75,
                        height: '1px',
                        backgroundColor: 'rgba(204, 204, 204, 0.5)',
                        zIndex: 0,
                    }}
                />
            ))}
        </>
    )}
    {/*we set height to section.fontSizeValuePx*/}
    {pdfItemsToRender.map((section, index) => (
        <div
            id={`section-${index}`}
            style={{
                position: 'absolute',
                top: (((section.position.y / 0.5) - margin) * 0.75) + 6,
                left: ((section.position.x / 0.5) - margin) * 0.75,
                display: 'flex',
                flexDirection: 'row',
                alignItems : 'center',
                zIndex: 10,
            }}
            key={index}
            dangerouslySetInnerHTML={{__html: prepareHtml(section, index)}}
        />
    ))}
    </body>
    </html>
    );
};

export default PdfForStonemasons;
